import { useEffect, useRef } from 'react';
import { BrowserRouter, Routes, Route, useNavigate } from 'react-router-dom';
import Lenis from 'lenis';
import '@/App.css';
import { Toaster } from '@/components/ui/sonner';
import { Hero } from '@/components/Hero';
import { Marquee } from '@/components/Marquee';
import { YouTubeLive } from '@/components/YouTubeLive';
import { Manifesto } from '@/components/Manifesto';
import { ShowSchedule } from '@/components/ShowSchedule';
import { Footer } from '@/components/Footer';
import LiveStagePage from '@/live/LiveStagePage';
import AdminPage from '@/admin/AdminPage';
import { getShowState } from '@/lib/shows';
import { useIST } from '@/hooks/useIST';

function Landing() {
  const navigate = useNavigate();
  const lenisRef = useRef(null);
  const ist = useIST();
  const auto = getShowState(ist);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    lenisRef.current = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#050505] font-body text-[#F5F5F5] antialiased">
      <Hero onWatchDraw={() => navigate('/live')} />
      <Marquee />
      <YouTubeLive />
      <ShowSchedule
        selectedId={auto.show.id}
        autoShowId={auto.show.id}
        status={auto.status}
        onSelect={(id) => navigate(`/live?show=${id}`)}
      />
      <Manifesto />
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/live" element={<LiveStagePage />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
      <Toaster theme="dark" position="bottom-center" />
    </BrowserRouter>
  );
}

export default App;
